module.exports = __webpack_public_path__ + "img/racecourse-turffontein-turf-inner-2000.96519571.svg";